import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useSpring, animated, config } from 'react-spring'
import { Home, Compare, AddCircle, UserSettings, Login, UserAdd } from 'grommet-icons'

import { AuthContext } from '../Firebase/Auth'

const Bottombar = () => {
  const barAnimation = useSpring({
    from: { transform: 'translate3d(0, -10rem, 0)' },
    transform: 'translate3d(0, 0, 0)'
  })

  const linkAnimation = useSpring({
    from: { transform: 'translate3d(0, 30px, 0)', opacity: 0 },
    to: { transform: 'translate3d(0, 0, 0)', opacity: 1 },
    delay: 800,
    config: config.wobbly
  })

  const { currentUser } = useContext(AuthContext)
  return (
    <BottomBar style={(barAnimation, { zIndex: '99999' })}>
      <FlexContainer>
        <NavLinks style={linkAnimation}>
          {currentUser && (
            <>
              <Link
                to={{
                  pathname: '/'
                }}
              >
                <Home />
                <span>My Properties</span>
              </Link>
              <Link
                to={{
                  pathname: '/compare'
                }}
              >
                <Compare />
                <span>Compare Properties</span>
              </Link>
              <Link
                to={{
                  pathname: '/add'
                }}
              >
                <AddCircle />
                <span>Add Property</span>
              </Link>
              <Link
                to={{
                  pathname: '/setup'
                }}
              >
                <UserSettings />
                <span>My Preferences</span>
              </Link>
            </>
          )}

          {!currentUser && (
            <>
              <Link
                to={{
                  pathname: '/login'
                }}
              >
                <Login />
                <span>Login</span>
              </Link>
              <Link
                to={{
                  pathname: '/signup'
                }}
              >
                <UserAdd />
                <span>Sign Up</span>
              </Link>
            </>
          )}
        </NavLinks>
      </FlexContainer>
    </BottomBar>
  )
}

export default Bottombar

const BottomBar = styled(animated.nav)`
  position: fixed;
  width: 100%;
  max-width: 500px;
  top: calc(100% - 5rem);
  left: 0;
  background: #fff;
  z-index: 1;
  font-size: 0.8rem;
  box-shadow: -3px -1px 5px rgba(0, 0, 0, 0.3);
`

const FlexContainer = styled.div`
  display: flex;
  padding: 0.5rem 1rem;
  height: 5rem;
`

const NavLinks = styled(animated.ul)`
  display: flex;
  list-style-type: none;
  align-items: space-between;
  justify-content: space-between;
  width: 100%;

  & a {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    span {
      line-height: 1.5;
    }
  }

  & a,
  button {
    color: #2b2b2b;
    font-weight: 400;
    border-bottom: 1px solid transparent;
    transition: all 300ms linear 0s;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #fdcb6e;
      border-bottom: 1px solid #fdcb6e;
    }
  }
`
